
import { Link } from 'react-router'
// @ts-ignore
import bannerMain from './../../../assets/media/banner/bannermain.png'

export function SliderChild(props: { image: string | File, title: string, text: string, buttonText: string, buttonLink: string }) {
    return (
        <>
            <section className="banner rounded-0 rounded-5 " style={{ backgroundImage: `url(${bannerMain})` }}>
                <div className=" h-100 w-100 py-3 rounded rounded-4">
                    <div className="h-100 container">
                        <div className="row h-100 w-100 align-items-end justify-content-end">
                            <div className="col-md-5">
                                <div data-aos="fade-down" data-aos-duration="1500" className='card banner-card card-body shadow border-0 rounded-4'>
                                    <div className='d-flex align-items-center gap-3 gx-3'>
                                        <div className='card-image'>
                                            <img src={
                                                props.image instanceof File
                                                    ? URL.createObjectURL(props.image)
                                                    : props.image || bannerMain
                                            } alt="bnenr" />
                                        </div>
                                        <div className='card-conttent'>
                                            <p className='mb-1 fw-bold'>
                                                آریا استیل راد
                                            </p>
                                            <p className='font-medium mb-0'>
                                                با کیفیت ترین باربیکیو ها...
                                            </p>
                                            <p className='text-end mb-0'>
                                                <Link to={'#'} className='text-text-decoration-none text-muted font-small-lg'>
                                                    مشاهده همه
                                                </Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}